import React from 'react'
import PropTypes from 'prop-types'

const AccessibilityIcon = (props) => {
  const { color = '#000000', classes = 'w-20' } = props
  return (
    <svg
      width="22"
      height="24"
      viewBox="0 0 22 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <path
        d="M15.8125 10.6125V9.23242H6.1875V10.6125H9.625V12.499L6.96575 17.1704L8.15925 17.8549L10.7112 13.3725H11.2888L13.8407 17.8549L15.0343 17.1704L12.375 12.499V10.6125H15.8125Z"
        fill={color}
      />
      <path
        d="M11 8.54327C11.7594 8.54327 12.375 7.92541 12.375 7.16324C12.375 6.40106 11.7594 5.7832 11 5.7832C10.2406 5.7832 9.625 6.40106 9.625 7.16324C9.625 7.92541 10.2406 8.54327 11 8.54327Z"
        fill={color}
      />
      <path
        d="M11 21.6544C9.09636 21.6544 7.23546 21.0879 5.65264 20.0264C4.06982 18.9649 2.83616 17.4562 2.10766 15.691C1.37917 13.9258 1.18856 11.9835 1.55995 10.1096C1.93133 8.2357 2.84802 6.51441 4.1941 5.1634C5.54018 3.8124 7.25519 2.89235 9.12226 2.51961C10.9893 2.14687 12.9246 2.33817 14.6833 3.06933C16.4421 3.80049 17.9453 5.03866 19.0029 6.62728C20.0605 8.2159 20.625 10.0836 20.625 11.9942C20.6221 14.5554 19.6071 17.0108 17.8027 18.8218C15.9983 20.6329 13.5518 21.6516 11 21.6544ZM11 3.71402C9.36831 3.71402 7.77326 4.19965 6.41655 5.10949C5.05984 6.01932 4.00242 7.31251 3.378 8.82552C2.75358 10.3385 2.5902 12.0034 2.90853 13.6096C3.22685 15.2158 4.01259 16.6912 5.16637 17.8492C6.32016 19.0072 7.79017 19.7958 9.39051 20.1153C10.9909 20.4348 12.6497 20.2708 14.1571 19.6441C15.6646 19.0174 16.9531 17.9561 17.8596 16.5944C18.7661 15.2328 19.25 13.6319 19.25 11.9942C19.2475 9.79894 18.3775 7.69429 16.8309 6.142C15.2842 4.5897 13.1873 3.71652 11 3.71402Z"
        fill={color}
      />
    </svg>
  )
}

AccessibilityIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(AccessibilityIcon)
